export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./act-request.vue?vue&type=template&id=394d0ea8&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/act-request.vue?vue&type=template&id=394d0ea8&
// module id = 1704
// module chunks = 0